export function replaceAt(str: string, index: number, replacement: any) {
  return str.substring(0, index) + replacement + str.substring(index + 1);
}
